import { useTranslation } from 'react-i18next';
import Button from '~/components/buttons/NewButton';
import ModalActions from '~/components/modals/Modal/ModalActions';
import Text from '~/components/typographies/Text';
import styles from './CompanySummary.module.scss';

export interface CompanySummaryData {
  name: string;
  vatNumber: string;
  taxNumber: string;
  companyIdentityId: string;
}

interface CompanySummaryProps {
  initialValue: CompanySummaryData;
  onSubmit: (data: CompanySummaryData) => void;
  onCancel: () => void;
}

interface DataRowProps {
  label: string;
  value: string;
}

const SummaryDataRow: React.FC<DataRowProps> = ({ label, value }) => {
  return (
    <div className={styles.row}>
      <Text variant="body2" weight="regular" className={styles.rowLabel}>
        {label}
      </Text>
      <Text variant="body2" weight="semibold" className={styles.rowValue}>
        {value}
      </Text>
    </div>
  );
};

const CompanySummary: React.FC<CompanySummaryProps> = ({ initialValue, onSubmit, onCancel }) => {
  const { t } = useTranslation('translations');

  return (
    <div className={styles.root}>
      <div className={styles.rows}>
        <SummaryDataRow label={t('NAME')} value={initialValue.name} />
        <SummaryDataRow label={t('TAX_NUMBER')} value={initialValue.taxNumber} />
        <SummaryDataRow label={t('VAT_NUMBER')} value={initialValue.vatNumber} />
      </div>
      <ModalActions>
        <Button onClick={() => onCancel()} variant="outlined">
          {t('BACK')}
        </Button>
        <Button onClick={() => onSubmit(initialValue)}>{t('CONFIRM')}</Button>
      </ModalActions>
    </div>
  );
};

export default CompanySummary;
